import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { ImageComponent } from '../../primitives/image/image.component';
import { ButtonComponent } from '../../primitives/button/button.component';

@Component({
    selector: 'app-script-button',
    templateUrl: './script-button.component.html',
    styleUrls: ['./script-button.component.scss'],
    imports: [ImageComponent, ButtonComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScriptButtonComponent {
  public mode = input<"default" | "web">("default");
  public enabled = input<boolean>(true);
  public actionClick = output();
  
  public title = signal<string>("Add your eScript");
  public description = signal<string>("You can then have it delivered, or just keep it safe in My Scripts.");
  public icon = signal<string>("script");
  public button = signal<string>("Add eScript");
  public isWeb = computed<boolean>(() => this.mode() == "web");

  onActionClick() {
    if (!this.enabled) return;
    this.actionClick.emit();
  }

}
